document.addEventListener('DOMContentLoaded', function() {
    const images = document.querySelectorAll('.images');
    const imagePrevBtn = document.getElementById('imagePrevBtn');
    const imageNextBtn = document.getElementById('imageNextBtn');
    const imagesList = document.querySelector('.images-list');

    if (images.length === 0) return;

    // Next button - navigate to next image with smooth scroll
    imageNextBtn.addEventListener('click', function() {
      scrollToNextImage();
    });

    // Previous button - navigate to previous image with smooth scroll
    imagePrevBtn.addEventListener('click', function() {
      scrollToPrevImage();
    });

    function scrollToNextImage() {
      const itemWidth = images[0].offsetWidth + 10; // including gap
      imagesList.scrollBy({
        left: itemWidth,
        behavior: 'smooth'
      });
    }

    function scrollToPrevImage() {
      const itemWidth = images[0].offsetWidth + 10; // including gap
      imagesList.scrollBy({
        left: -itemWidth,
        behavior: 'smooth'
      });
    }
  });